export default __webpack_public_path__ + "static/IBMPlexSans-LightItalic-Latin1-40e1012bdd73a02c83f89cb9ea860b63.woff";